export function createIdempotencyKey(prefix: string): string {
  const randomUuid =
    typeof globalThis.crypto?.randomUUID === 'function'
      ? globalThis.crypto.randomUUID()
      : undefined;
  return `${prefix}-${randomUuid ?? `${Date.now()}-${Math.random()}`}`;
}
